import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  unreadMessagesCount: 0,
  unreadAppointmentsCount: 0,
  alerts: [], // [{ id: string, type: 'info'|'warning'|'success'|'error', title: string, message: string, timestamp: number }]
};

export const notificationSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    setUnreadMessagesCount: (state, action) => {
      state.unreadMessagesCount = Math.max(0, Number(action.payload) || 0);
    },
    incrementUnreadMessages: (state) => {
      state.unreadMessagesCount += 1;
    },
    decrementUnreadMessages: (state) => {
      state.unreadMessagesCount = Math.max(0, state.unreadMessagesCount - 1);
    },
    setUnreadAppointmentsCount: (state, action) => {
      state.unreadAppointmentsCount = Math.max(0, Number(action.payload) || 0);
    },
    addAlert: (state, action) => {
      state.alerts.unshift({
        id: action.payload.id || `alert-${Date.now()}-${Math.random().toString(36).substr(2, 4)}`,
        type: action.payload.type || 'info',
        title: action.payload.title || '',
        message: action.payload.message || '',
        timestamp: Date.now(),
      });
      // Cap at 20 alerts
      if (state.alerts.length > 20) {
        state.alerts = state.alerts.slice(0, 20);
      }
    },
    dismissAlert: (state, action) => {
      state.alerts = state.alerts.filter((a) => a.id !== action.payload);
    },
    clearAllAlerts: (state) => {
      state.alerts = [];
    },
  },
});

export const {
  setUnreadMessagesCount,
  incrementUnreadMessages,
  decrementUnreadMessages,
  setUnreadAppointmentsCount,
  addAlert,
  dismissAlert,
  clearAllAlerts,
} = notificationSlice.actions;

// Selectors
export const selectNotificationsState = (state) => state.notifications;
export const selectUnreadMessagesCount = (state) => state.notifications.unreadMessagesCount;
export const selectUnreadAppointmentsCount = (state) => state.notifications.unreadAppointmentsCount;
export const selectAlerts = (state) => state.notifications.alerts;

export default notificationSlice.reducer;
